import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { liveCheckinMonthsService } from '../../services/lives-checkins-months'

export const GET_OR_CREATE_MONTH_KEY = 'getOrCreateLiveCheckinMonthCurrent'

export function useGetOrCreateMonth(userId: number | null | undefined) {
  const queryClient = useQueryClient()

  const enabled = !!userId
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [GET_OR_CREATE_MONTH_KEY, userId],
    enabled,
    queryFn: () => liveCheckinMonthsService.getOrCreateCurrent({ userId: userId! }),
  })

  const mutation = useMutation({
    mutationFn: (uid: number) =>
      liveCheckinMonthsService.getOrCreateCurrent({ userId: uid }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_OR_CREATE_MONTH_KEY] })
    },
  })

  return {
    month: data?.data,
    isLoading,
    error: (error as Error | null) ?? null,
    apiError: data?.error ?? null,
    refetch,
    forceCreate: mutation.mutate,
  }
}
